import { useLang } from "../context/LanguageContext";
import { Instagram, Mail, Globe } from "lucide-react";

const INSTAGRAM_URL = "https://instagram.com/airdronejet";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-white/10 bg-[#0B0E14] mt-24" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-5">
            <img src="/adj-logo.png" alt="ADJ" className="h-11 w-11 object-contain" />
            <div className="leading-none">
              <span className="font-display font-extrabold text-xl text-white">ADJ ACADEMIA</span>
              <span className="font-mono text-[10px] block tracking-[0.3em] text-[#F5842B] mt-1">AIRDRONEJET</span>
            </div>
          </div>
          <p className="text-slate-400 text-sm max-w-md leading-relaxed">{t("footer.tagline")}</p>
          <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 mt-6 glass rounded-full px-4 py-2.5 text-sm text-white hover:border-[#F5842B]/50 transition-colors" data-testid="footer-instagram">
            <Instagram size={17} className="text-[#F5842B]" /> @airdronejet
          </a>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-[#F5842B]/90 mb-4">{t("footer.coursesTitle")}</h4>
          <ul className="space-y-2.5 text-sm text-slate-400">
            <li>Foundation</li>
            <li>Pro Operations</li>
            <li>Safety &amp; Emergency</li>
            <li>Surface Specialist</li>
            <li>Business &amp; Project</li>
          </ul>
        </div>
        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.25em] text-[#F5842B]/90 mb-4">{t("footer.contactsTitle")}</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li>
              <a href="mailto:info@airdronejet.com" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-email">
                <Mail size={15} /> info@airdronejet.com
              </a>
            </li>
            <li>
              <a href="https://www.airdronejet.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-website">
                <Globe size={15} /> www.airdronejet.com
              </a>
            </li>
            <li>
              <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-white transition-colors">
                <Instagram size={15} /> @airdronejet
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center text-xs text-slate-500 font-mono tracking-wider">
        © {new Date().getFullYear()} ADJ AIRDRONEJET — {t("footer.rights")}
      </div>
    </footer>
  );
}
